import React, { memo } from "react";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { ORDER_PLACEMENT_CONSTANTS, IMAGES } from "./constant";
import { HeadingTitleContainer, DescriptionContainer, ContentContainer } from "./styled";

const OrderPlacementContent = memo(() => {
    return (
        <ContentContainer>
            <Image
                src={IMAGES.ORDER_SUCCESS}
                alt={ORDER_PLACEMENT_CONSTANTS.IMAGE_ALT}
                cloudinaryHeight={ORDER_PLACEMENT_CONSTANTS.ICON_HEIGHT * 2}
                cloudinaryWidth={ORDER_PLACEMENT_CONSTANTS.ICON_WIDTH * 2}
                height={String(ORDER_PLACEMENT_CONSTANTS.ICON_HEIGHT)}
                width={String(ORDER_PLACEMENT_CONSTANTS.ICON_WIDTH)}
            />

            <HeadingTitleContainer>
                <Text variant="V2.heading1.neutral.black" color="text_Highest_Emphasis">
                    {ORDER_PLACEMENT_CONSTANTS.TITLE}
                </Text>
            </HeadingTitleContainer>

            <DescriptionContainer>
                <Text variant="V2.body1.neutral.regular" color="text_Low_Emphasis">
                    {ORDER_PLACEMENT_CONSTANTS.SUBTITLE}
                </Text>
            </DescriptionContainer>
        </ContentContainer>
    );
});

OrderPlacementContent.displayName = "OrderPlacementContent";

export default OrderPlacementContent;
